import formStyles from './styles/Forms.module.scss';
import Page from './layouts/Page';
import { AuthService, PasswordResetEmailRequestModel } from '../api/auth';
import { useState } from 'react';
import { Grid, Typography, TextField } from '@material-ui/core';
import { SubmitHandler, useForm } from 'react-hook-form';
import LoadingSpinner from '../dashboard/components/LoadingSpinner';

const ForgetPassword = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isEmailSent, setIsEmailSent] = useState(false);

  const { register, handleSubmit, setError, formState } = useForm<PasswordResetEmailRequestModel>();

  const requestPasswordResetEmail: SubmitHandler<PasswordResetEmailRequestModel> = (data) => {
    setIsLoading(true);

    AuthService.requestPasswordResetEmail(data)
      .then(() => {
        setIsLoading(false);
        setIsEmailSent(true);
      })
      .catch((err) => {
        setIsLoading(false);
        if (err.response.status === 400) {
          setError('email', { type: 'manual', message: 'Email address not found' });
        }
      });
  };

  return (
    <Page>
      {isLoading && <LoadingSpinner attachToRoot />}
      <div className="containerFixed page-content">
        <h1>Forget password</h1>
        <p>Please enter your email address so we can send you the password reset link</p>
        <Grid
          component="form"
          onSubmit={handleSubmit(requestPasswordResetEmail)}
          noValidate
          container
          flexDirection="column"
          sx={{ marginTop: '1rem' }}
        >
          <Grid item container spacing={2}>
            <Grid item xs md={6}>
              <TextField
                label="Email Address"
                {...register('email', {
                  required: { value: true, message: 'Please enter your email address' },
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: 'Invalid email address',
                  },
                })}
                helperText={formState.errors.email?.message}
                error={!!formState.errors.email}
              />
            </Grid>
          </Grid>

          <Grid item container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={6}>
              {isEmailSent && (
                <Typography variant="body2" color="green" align="left" sx={{ py: 3 }}>
                  Please check your email for the password reset link
                </Typography>
              )}
              {!isEmailSent && (
                <button disabled={isLoading} type="submit" className={formStyles.submit} style={{ width: '100%' }}>
                  Send Password Reset Link
                </button>
              )}
            </Grid>
          </Grid>
        </Grid>
      </div>
    </Page>
  );
};

export default ForgetPassword;
